import clsx from 'clsx';

import { ClassNameProps } from '@/types/common.types';

import type { CollectionList } from '@/api/types/collections.types';

import { CardBody, CardSubtitle, CardTitle } from '@/components/Card';
import styles from '@/components/CollectionCard/CollectionCard.module.scss';
import { CollectionCardImage } from '@/components/CollectionCard/CollectionCardImage';
import { ForwardedLink } from '@/components/ForwardedLink';

interface CollectionCardProps extends ClassNameProps {
  collection: CollectionList;
  href: string;
}

export const CollectionCard = (props: CollectionCardProps) => {
  const { collection, href, className } = props;
  const { description, poster, title } = collection;

  return (
    <ForwardedLink href={href} className={clsx(styles.collectionCard, className)}>
      <CollectionCardImage poster={poster} title={title} />
      <CardBody>
        <CardTitle>{title}</CardTitle>
        <CardSubtitle>{description}</CardSubtitle>
      </CardBody>
    </ForwardedLink>
  );
};
